import { defineComponent as _defineComponent } from 'vue'
import { Note } from './ExpedientReminderNotesComponentTypes'
import { PropType } from 'vue/types/v3-component-props'
import ReminderNoteComponent from '@/components/widgets/ExpedientWidgets/ExpedientReminderNotes/ReminderNoteComponent.vue'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'ReminderNotesContainerComponent',
  props: {
  notes: {
    type: Array as PropType<Note[]>,
    required: true
  }
},
  emits: ['edit-note', 'show-remove-dialog'],
  setup(__props, { emit }) {

const props = __props;



// EVENTS


// METHODS
function editNote(note: Note) {
  emit('edit-note', note)
}

function showRemoveDialog(note: Note) {
  emit('show-remove-dialog', note)
}

return { __sfc: true,props, emit, editNote, showRemoveDialog, ReminderNoteComponent }
}

})